import styled from 'styled-components';
import { GamePickerWrapper } from '@gameday/gamePicker/gamePicker/GamePicker.style';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import { ControlledOverflowOverride } from 'bdata-react-mini-scoreboard-refresh/lib/components/MiniScoreboardGrid/MiniScoreboardGrid.style';
import { GenericWrapper, ContentWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/MiniScoreboardGame.style';
import ClickThroughWrapper from 'bdata-sns-shared/mini/components/ClickthroughWrapper';
import { PromotionLabelWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/GameInfoLayer/GameInfoLayer.style';
import { ScoreWrapper as TeamScoreWrapper, RecordWrapper, ScoreContainer } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/TeamMatchupLayer/TeamMatchupLayer.style';
import { IconWrapper } from '@mlb/react-patterns/v4/components/AccordionItem/AccordionItem.style';
import { ScoreWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/VerticalGame.style';
import { NameWrapper, DesktopRecordWrapper } from '@mlb/react-patterns/v4/components/Team/team.style';
import { InnerWrapper, LeftButton, RightButton } from '@mlb/react-patterns/v4/components/ControlledOverflow/controlledOverflow.style';
import { ViewingActiveGameWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/GameDataLayer/GameDataLayer.style';
import { GameStateLabelWrapper, TagOverride } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/StatusLayer/StatusLayer.style';
import { MODAL_BREAKPOINT_DESKTOP } from '@gameday/components/themes/breakpoints';
const {
    mlbGrey2
} = COLORS;

export const HeaderWrapper = styled.div`
    position: relative;
    z-index:112;
`;

export const ScoreboardButtonWrapper = styled(IconWrapper)`
    box-shadow: none;
    display: none;
    border: 1px solid ${mlbGrey2};
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform-origin: 50% 50%;
    transform: ${({ iconRotated }) => iconRotated ? 'translateX(-50%) rotate(180deg)' : 'translateX(-50%) rotate(0)'};
    z-index: 2;
    opacity: 1;
    cursor: pointer;
    svg {
        fill: #868686;
    }
`;

export const ScoreboardWrapper = styled.div`
    position: relative;
    border-bottom: 1px solid var(--gameday-divider-color);
    min-height: 74px;
    display: none; // default to false
    ${ContentWrapper} {
        background-color: var(--gameday-background-color);
        border: 1px solid var(--gameday-divider-color) !important;
        &:hover {
            border-color: var(--gameday-oot-scoreboard-border-hover) !important;
        }
        &.selected {
            border-color: var(--gameday-oot-scoreboard-border-selected) !important;
            box-shadow: var(--gameday-oot-scoreboard-border-selected) 0px 0px 0px 1px inset !important;
        }
        ${TeamScoreWrapper} {
            color: var(--gameday-primary-font-color);
        }
        ${ViewingActiveGameWrapper} {
            color: var(--gameday-secondary-font-color);
        }
        ${GameStateLabelWrapper} {
            color: var(--gameday-secondary-font-color);
        }
        ${RecordWrapper} {
            color: var(--gameday-secondary-font-color);
        }
        ${PromotionLabelWrapper} {
            color: var(--gameday-primary-font-color);
        }
        ${TagOverride} {
            background-color: var(--gameday-scoreboard-notable-game-highlight);
        }
    }

    ${GamePickerWrapper} {
        padding: 0 0 0 16px;
        background-color: var(--gameday-background-color);

        ${ScoreContainer} {
            padding-left: 10px;
            > div {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
            }
        }

        ${ControlledOverflowOverride} {
            ${GenericWrapper} {
                margin-bottom: 1px;
            }
            ${InnerWrapper} {
                border-right: 1px solid var(--gameday-divider-color);
            }
            ${RightButton} {
                background-color: var(--gameday-background-color);
                border: 1px solid var(--gameday-divider-color);
            }
            ${LeftButton} {
                background-color: var(--gameday-background-color);
                border: 1px solid var(--gameday-divider-color);
                &:disabled {
                    background-color: var(--gameday-divider-color);
                    border-color: var(--gameday-oot-scoreboard-border-disabled)
                    svg {
                        use {
                            path {
                                fill: #C4C4C4;
                            }
                        }
                    }
                }
            }
        }
    }
    ${({ $sbVisibility }) => ($sbVisibility) ? 'display:block' : 'display: none'};
`;

export const VerticalMiniWrapper = styled.div`
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    div[class*="EmptyWrapper"] {
        div {
            color: var(--gameday-secondary-font-color) !important;
        }
    }
    ${ContentWrapper} {
        background-color: var(--gameday-background-color);
        border-bottom: 1px solid var(--gameday-divider-color) !important;
        &:hover {
                border-bottom: 1px solid var(--gameday-divider-color) !important;
            }
        }

    }
    ${ScoreWrapper} {
        color: var(--gameday-primary-font-color);
    }
    ${NameWrapper} {
        color: var(--gameday-primary-font-color);
    }
    ${DesktopRecordWrapper} {
        color: var(--gameday-secondary-font-color);
    }
    ${GenericWrapper} {
        &:last-child {
            ${ContentWrapper} {
                border-bottom: none !important;
            }
        }
        ${ClickThroughWrapper} {
            position: relative;
            display: block;
            width: 100%;
            left: -1px;
            font-family: var(--gameday-primary-font);
        }
    }
    ${TagOverride} {
        background-color: var(--gameday-scoreboard-notable-game-highlight);
    }
`;

export const VerticalGameMobileHeader = styled.div`
    box-sizing: border-box;
    width: 100%;
    font-size: 20px;
    line-height: 22px;
    color: var(--gameday-primary-font-color);
    font-weight: 700;
    text-align: center;
    display: block;
    padding: 16px;
    @media (min-width: ${MODAL_BREAKPOINT_DESKTOP}) {
        display: none;
    }
`;
